export default [
  //Parametrização Comum
  {
    path: 'elementos-comuns/parametrizacao-comum/paises',
    name: 'elementosComuns_parametrizacaoComum_paises',
    component: () => import(/* webpackChunkName: "paises" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/paises.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.paises',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/documentos-de-origem',
    name: 'elementosComuns_parametrizacaoComum_documentosDeOrigem',
    component: () => import(/* webpackChunkName: "documentosDeOrigem" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/documentosDeOrigem.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.documentosOrigem',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/departamentos',
    name: 'elementosComuns_parametrizacaoComum_departamentos',
    component: () => import(/* webpackChunkName: "departamentos" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/departamentos.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.departamentos',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/moedas',
    name: 'elementosComuns_parametrizacaoComum_moedas',
    component: () => import(/* webpackChunkName: "moedas" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/moedas.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.moedas',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/instrumentos-bancarios',
    name: 'elementosComuns_parametrizacaoComum_instrumentosBancarios',
    component: () => import(/* webpackChunkName: "instrumentosBancarios" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/instrumentosBancarios/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.instrumentosBancarios',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/calendarios',
    name: 'elementosComuns_parametrizacaoComum_calendarios',
    component: () => import(/* webpackChunkName: "calendarios" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/calendarios/calendarios.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.calendarios',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/corretoras',
    name: 'elementosComuns_parametrizacaoComum_corretoras',
    component: () => import(/* webpackChunkName: "corretoras" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/corretoras/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.corretoras',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/bancos',
    name: 'elementosComuns_parametrizacaoComum_bancos',
    component: () => import(/* webpackChunkName: "bancos" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/bancos.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.bancos',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/beneficiarios-remetentes',
    name: 'elementosComuns_parametrizacaoComum_beneficiariosRemetentes',
    component: () => import(/* webpackChunkName: "beneficiariosRemetentes" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/beneficiariosRemetentes/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.beneficiariosRemetentes',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/unidades-de-negocios',
    name: 'elementosComuns_parametrizacaoComum_unidadesDeNegocios',
    component: () => import(/* webpackChunkName: "unidadesDeNegocios" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/unidadesDeNegocios.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.unidadesDeNegocios',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/seguradoras',
    name: 'elementosComuns_parametrizacaoComum_seguradoras',
    component: () => import(/* webpackChunkName: "seguradoras" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/seguradoras/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.seguradoras',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/empresas',
    name: 'elementosComuns_parametrizacaoComum_empresas',
    component: () => import(/* webpackChunkName: "empresas" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/empresas/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.empresas',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/paridade',
    name: 'elementosComuns_parametrizacaoComum_paridade',
    component: () => import(/* webpackChunkName: "paridade" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/paridade'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.paridade',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/agencias',
    name: 'elementosComuns_parametrizacaoComum_agencias',
    component: () => import(/* webpackChunkName: "agencias" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/agencias/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.agencias',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-comum/conta-corrente',
    name: 'elementosComuns_parametrizacaoComum_contaCorrente',
    component: () => import(/* webpackChunkName: "contaCorrente" */ '@/views/modules/ElementosComuns/ParametrizacaoComum/contaCorrente/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoComum.contaCorrente',
      tab: true,
    },
  },

  //Planos de Contas
  {
    path: 'elementos-comuns/planos-de-contas/tipos-de-contas-financeiras',
    name: 'elementosComuns_planosDeContas_tiposDeContasFinanceiras',
    component: () => import(/* webpackChunkName: "tiposDeContasFinanceiras" */ '@/views/modules/ElementosComuns/PlanosDeContas/tiposDeContasFinanceiras.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.planosDeContas.tiposDeContasFinanceiras',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/planos-de-contas/contas-contabeis',
    name: 'elementosComuns_planosDeContas_contasContabeis',
    component: () => import(/* webpackChunkName: "contasContabeis" */ '@/views/modules/ElementosComuns/PlanosDeContas/contasContabeis.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.planosDeContas.contasContabeis',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/planos-de-contas/planos-contas-alternativos',
    name: 'elementosComuns_planosDeContas_planosContasAlternativos',
    component: () => import(/* webpackChunkName: "planosContasAlternativos" */ '@/views/modules/ElementosComuns/PlanosDeContas/planosContasAlternativos/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.planosDeContas.planosContasAlternativas',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/planos-de-contas/contas-financeiras-x-contabeis',
    name: 'elementosComuns_planosDeContas_contasFinanceirasXContabeis',
    component: () => import(/* webpackChunkName: "contasFinanceirasXContabeis" */ '@/views/modules/ElementosComuns/PlanosDeContas/contasFinanceirasXContabeis.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.planosDeContas.contasFinanceirasXContabeis',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/planos-de-contas/contas-economicas',
    name: 'elementosComuns_planosDeContas_contasEconomicas',
    component: () => import(/* webpackChunkName: "contasEconomicas" */ '@/views/modules/ElementosComuns/PlanosDeContas/contasEconomicas.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.planosDeContas.contasEconomicas',
      tab: true,
    },
  },

  //Grupos
  {
    path: 'elementos-comuns/grupos/divisoes',
    name: 'elementosComuns_grupos_divisoes',
    component: () => import(/* webpackChunkName: "divisoes" */ '@/views/modules/ElementosComuns/Grupos/divisoes/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.grupos.divisoes',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/grupos/grupos-de-bancos',
    name: 'elementosComuns_grupos_gruposDeBancos',
    component: () => import(/* webpackChunkName: "gruposDeBancos" */ '@/views/modules/ElementosComuns/Grupos/gruposDeBancos/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.grupos.gruposBancos',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/grupos/grupos-unidades-negocios',
    name: 'elementosComuns_grupos_gruposUnidadesNegocios',
    component: () => import(/* webpackChunkName: "gruposUnidadesNegocios" */ '@/views/modules/ElementosComuns/Grupos/gruposUnidadesNegocios/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.grupos.gruposUnidadesNegocios',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/grupos/grupos-de-moedas',
    name: 'elementosComuns_grupos_gruposDeMoedas',
    component: () => import(/* webpackChunkName: "gruposDeMoedas" */ '@/views/modules/ElementosComuns/Grupos/gruposDeMoedas/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.grupos.gruposDeMoedas',
      tab: true,
    },
  },

  //Índices Econômicos
  {
    path: 'elementos-comuns/indices-economicos/provedores-de-indices-economicos',
    name: 'elementosComuns_indicesEconomicos_provedoresDeIndicesEconomicos',
    component: () => import(/* webpackChunkName: "provedoresDeIndicesEconomicos" */ '@/views/modules/ElementosComuns/IndicesEconomicos/provedoresDeIndicesEconomicos.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.indicesEconomicos.provedoresDeIndicesEconomicos',
      tab: true,
    },
  },

  //Administração Comum
  {
    path: 'elementos-comuns/administracao-comum/conexoes-ativas',
    name: 'elementosComuns_administracaoComum_conexoesAtivas',
    component: () => import(/* webpackChunkName: "conexoesAtivas" */ '@/views/modules/ElementosComuns/AdministracaoComum/conexoesAtivas.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.administracaoComum.conexoesAtivas',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/administracao-comum/sessoes-ativas',
    name: 'elementosComuns_administracaoComum_sessoesAtivas',
    component: () => import(/* webpackChunkName: "sessoesAtivas" */ '@/views/modules/ElementosComuns/AdministracaoComum/sessoesAtivas.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.administracaoComum.sessoesAtivas',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/administracao-comum/matriz-de-aprovacao',
    name: 'elementosComuns_administracaoComum_matrizdeAprovacao',
    component: () => import(/* webpackChunkName: "matrizdeAprovacao" */ '@/views/modules/ElementosComuns/AdministracaoComum/matrizdeAprovacao.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.administracaoComum.matrizdeAprovacao',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/administracao-comum/grupos-de-usuarios',
    name: 'elementosComuns_administracaoComum_gruposdeUsuarios',
    component: () => import(/* webpackChunkName: "gruposdeUsuarios" */ '@/views/modules/ElementosComuns/AdministracaoComum/gruposDeUsuarios/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.administracaoComum.gruposdeUsuarios',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/administracao-comum/usuarios',
    name: 'elementosComuns_administracaoComum_usuarios',
    component: () => import(/* webpackChunkName: "usuarios" */ '@/views/modules/ElementosComuns/AdministracaoComum/usuarios/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.administracaoComum.usuarios',
      tab: true,
    },
  },
  
  //Parametrização Específica e Interfaces
  {
    path: 'elementos-comuns/parametrizacao-especifica-interfaces/interface-contabil',
    name: 'elementosComuns_parametrizacaoEspecificaInterfaces_interfaceContabil',
    component: () => import(/* webpackChunkName: "interfaceContabil" */ '@/views/modules/ElementosComuns/ParametrizacaoEspecificaEInterfaces/interfaceContabil.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoEspecificaInterfaces.interfaceContabil',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-especifica-interfaces/integracoes-de-para',
    name: 'elementosComuns_parametrizacaoEspecificaInterfaces_integracoesDePara',
    component: () => import(/* webpackChunkName: "integracoesDePara" */ '@/views/modules/ElementosComuns/ParametrizacaoEspecificaEInterfaces/integracoesDePara.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoEspecificaInterfaces.integracoesDePara',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-especifica-interfaces/param-programacao-financeira',
    name: 'elementosComuns_parametrizacaoEspecificaInterfaces_paramProgramacaoFinanceira',
    component: () => import(/* webpackChunkName: "paramProgramacaoFinanceira" */ '@/views/modules/ElementosComuns/ParametrizacaoEspecificaEInterfaces/paramProgramacaoFinanceira.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoEspecificaInterfaces.paramProgramacaoFinanceira',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-especifica-interfaces/monitor-de-integracao-entrada',
    name: 'elementosComuns_parametrizacaoEspecificaInterfaces_monitordeIntegracaoEntrada',
    component: () => import(/* webpackChunkName: "monitordeIntegracaoEntrada" */ '@/views/modules/ElementosComuns/ParametrizacaoEspecificaEInterfaces/monitordeIntegracaoEntrada.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoEspecificaInterfaces.monitordeIntegracaoEntrada',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-especifica-interfaces/agendamento-de-processos',
    name: 'elementosComuns_parametrizacaoEspecificaInterfaces_agendamentodeProcessos',
    component: () => import(/* webpackChunkName: "agendamentodeProcessos" */ '@/views/modules/ElementosComuns/ParametrizacaoEspecificaEInterfaces/agendamentodeProcessos.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoEspecificaInterfaces.agendamentodeProcessos',
      tab: true,
    },
  },
  {
    path: 'elementos-comuns/parametrizacao-especifica-interfaces/tabelas-customizadas',
    name: 'elementosComuns_parametrizacaoEspecificaInterfaces_tabelasCustomizadas',
    component: () => import(/* webpackChunkName: "tabelasCustomizadas" */ '@/views/modules/ElementosComuns/ParametrizacaoEspecificaEInterfaces/tabelasCustomizadas.vue'),
    meta: {
      middleware: [],
      title: 'modulo.elementosComuns.parametrizacaoEspecificaInterfaces.tabelasCustomizadas',
      tab: true,
    },
  },
];

